// extracted by mini-css-extract-plugin
export var card = "amazon_link-module--card--u8PJL";
export var content = "amazon_link-module--content--M8nZj";
export var image = "amazon_link-module--image--GNQWf";
export var title = "amazon_link-module--title--1OKDp";
export var description = "amazon_link-module--description--2z8QD";
export var price = "amazon_link-module--price--187fa";
export var fetchedAt = "amazon_link-module--fetchedAt--F5Fmd";
export var domain = "amazon_link-module--domain--2UW3t";